<div>
  <h2>
    {{ 'ARC_SHARED_COMPONENTS_PRESENTATION_CODEVERIFICATION_DESCRIPTION' | translate }}
    <span class="nowrap">{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_BILLTRUST_ID' | translate }}</span>
  </h2>

  <form [formGroup]="loginFormGroup" class="p-grid p-nogutter" (ngSubmit)="onSignin()">
    <div class="p-col-12" *ngIf="msgs && msgs.length > 0">
      <p-messages [(value)]="msgs"></p-messages>
    </div>

    <div class="p-col-12 ui-md-12">
      <aur-input #email inputId="email-input" [autofocus]="true" formControlName="email"
        [label]="'ARC_SHARED_COMPONENTS_EMAIL_ADDRESS_LABEL' | translate" (valueChange)="emailValueChanged($event)"
        [errorMessages]="{
          'email': 'ARC_SHARED_COMPONENTS_PRESENTATION_USER_NAME_REQUIRED_ERROR' | translate
        }" (keydown.enter)="onEmailEnterKey(email.value)"></aur-input>
    </div>
    <div class="p-col-12 ui-md-12">
      <aur-input #password inputId="password-input" type="password" [autofocus]="false" autocomplete="current-password"
        formControlName="password" [label]="'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_LABEL' | translate"
        (valueChange)="passwordValueChanged($event)" [errorMessages]="{
          'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQUIRED_ERROR' | translate
        }" (keydown.enter)="onPasswordEnterKey(password.value)"></aur-input>
    </div>
    <div class="p-col-12 ui-md-12 forgot-wrapper">
      <button id="btnForgotPassword" type="button" [class.disabled]="submitting" (click)="onForgotPassword()" aur-button
        importance="link">{{
        'ARC_COMPOSITE_FORGOT_PASSWORD' | translate }}</button>
    </div>
    <div class="p-col-12 ui-md-12">
      <button type="submit" id="btnSignIn" class="sign-in-button" aur-button [disabled]="submitting">{{
        'ARC_SHARED_COMPONENTS_PRESENTATION_SIGNIN_BUTTON' | translate }}</button>
    </div>
    <div class="policy-wrapper">
      <ng-container *ngIf="jpmorganEConsent; else defaultPolicy">
        {{'ARC_SHARED_COMPONENTS_PRESENTATION_JPM_PRIVACY_POLICY_TEXT' | translate}}
        <a href="{{privacyPolicy}}" target="_blank">{{'ARC_SHARED_COMPONENTS_PRESENTATION_PRIVACY_POLICY_LINK'
          | translate}}</a>
        {{ 'ARC_SHARED_COMPONENTS_PRESENTATION_JPM_ECONSENT_TEXT' | translate }}
        <button id="btnJPMorganEconsent" type="button" aur-button (click)="showEConsentDialog()" importance="link">
          {{'ARC_SHARED_COMPONENTS_PRESENTATION_JPM_ECONSENT_LINK' | translate}}
        </button>
        <p-dialog [(visible)]="econsentDialogVisible" [modal]="true" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
          <ng-template pTemplate="header">
            <h4 class="econsent-header">{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_JPM_ECONSENT_LINK' | translate }}</h4>
          </ng-template>
          <app-jpmorgan-econsent></app-jpmorgan-econsent>
          <ng-template pTemplate="footer">
            <div class="econsent-footer">
              <button aur-button (click)="econsentDialogVisible = false">{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_JPM_ECONSENT_BUTTON' | translate }}</button>
            </div>
          </ng-template>
        </p-dialog>
      </ng-container>
      <ng-template #defaultPolicy>
        {{'ARC_SHARED_COMPONENTS_PRESENTATION_PRIVACY_POLICY_TEXT' | translate}}
        <a href="{{privacyPolicy}}" target="_blank">
          {{'ARC_SHARED_COMPONENTS_PRESENTATION_PRIVACY_POLICY_LINK' | translate}}
        </a>
      </ng-template>      
    </div>
  </form>
</div>